import { render, staticRenderFns } from "./index.vue?vue&type=template&id=203fbd6a&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=203fbd6a&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=203fbd6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203fbd6a",
  null
  
)

export default component.exports